import { render, staticRenderFns } from "./DocumentSynthesisList.vue?vue&type=template&id=2d67654a"
import script from "./DocumentSynthesisList.vue?vue&type=script&lang=ts"
export * from "./DocumentSynthesisList.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSynthesisList.vue?vue&type=style&index=0&id=2d67654a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports